export const LOG_STATUS = Object.freeze({
    SUCCESS: "SUCCESS",
    WARNING: "WARNING",
    ERROR: "ERROR"
});



// WEBPACK FOOTER //
// ./src/components/admin/logs/constants.js